export const PLATFORM_ENTITY = 'Authentic';

/** Item/product color class for catalog and invoice item rows. Use this so colors stay consistent. */
export const ITEM_COLOR_CLASS = 'bg-main-200';

export const ROLE_COLORS = [
  'bg-royal',
  'bg-forest',
  'bg-amber',
  'bg-purple',
  'bg-magenta',
  'bg-asset-green',
  'bg-liability-red',
  'bg-income-blue',
] as const;

export const getRoleColor = (role: string): string => {
  const hash = role
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return ROLE_COLORS[hash % ROLE_COLORS.length];
};

export const ALL_ROLES_VALUE = '__all__';

export const TILE_BORDER = 'border-r-[0.5px] border-b-[0.5px] border-main-200';

export const FILLER_BORDER = 'border-r-[0.5px] border-main-200';
